import { render, staticRenderFns } from "./ChipRow.vue?vue&type=template&id=696a96e4"
import script from "./ChipRow.vue?vue&type=script&lang=js"
export * from "./ChipRow.vue?vue&type=script&lang=js"
import style0 from "./ChipRow.vue?vue&type=style&index=0&id=696a96e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports